import { USCurrency } from '../components/ReusableComponents/FormattedPrice/index'

export async function checkIfImageExists(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = url

    img.onload = () => {
      resolve('loaded')
    }

    img.onerror = () => {
      reject('error!')
    }
  })
}

export function isFileTypeAllowed() {
  //return allowedFileTypes.some(arrValue => fileType === arrValue);
  return true
}
export function isFileSizeAllowed() {
  //return (filesize / Math.pow(1024, 2)).toFixed(2) < allowedFileSize ? true : false;
  return true
}

export const formatPrice = price => <USCurrency>{price}</USCurrency>

export function copyToClipboard(e, textToInsert) {
  let textField = document.createElement('textarea')
  textField.innerText = textToInsert
  textField.setAttribute('readonly', '')
  textField.style.position = 'absolute'
  textField.style.left = '-9999px'
  document.body.appendChild(textField)
  textField.select()
  document.execCommand('copy')
  textField.remove()
  e.target.focus()
  document.querySelector('.copied').classList.add('visible')

  setTimeout(function () {
    document.querySelector('.copied').classList.remove('visible')
  }, 2000)
}

export const slugify = value =>
  encodeURIComponent(value.toLowerCase().replace(/[^a-z0-9_-]+/gi, '-'))

export const titleCase = str => {
  if (str) {
    var splitStr = str.toLowerCase().split(' ')
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    return splitStr.join(' ')
  }
}

export function getCleanUrl(url) {
  if (url) {
    return url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')
  } else {
    return null
  }
}

export function getIconFromURl(url) {
  const src = 'https://www.google.com/s2/favicons?domain=' + url
  return <img src={src} alt="url" />
}

export function unescapeRegex(str) {
  if (!str) return null
  return str.replace(/\\n+(\\ )+|\\(?=[\s#([\]\){}|?$*])|\\(?=\.)|\\n/gm, '')
}

export const formatPhoneNumber = number => {
  var cleaned = ('' + number).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})?(\d{4})?$/)
  if (match) {
    var intlCode = match[1] ? '+1 ' : ''
    return [
      intlCode,
      '(',
      match[2],
      match[3] ? ') ' : '',
      match[3],
      match[4] ? '-' : '',
      match[4]
    ].join('')
  } else {
    return number
  }
}
